export const iconFontAwesomeMoneySterlingSign = (
	<i className="fa-solid fa-sterling-sign"></i>
);
